<template>
  <b-card title="Job Timeline">
    <app-timeline>
      <app-timeline-item
        v-for="timeline in safeJobTimeline"
        :key="timeline.id || timeline.title"
        :variant="timeline.type"
        :title="timelineTitle(timeline)"
        :time="timelineTime(timeline)"
      >
        <div>
        <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
          <h6>{{ timelineTitle(timeline) }}</h6>
          <small class="timeline-item-time text-nowrap text-muted">{{ timelineTime(timeline) }}</small>
        </div>
        <template v-if="isCandidateTimelineEvent(timeline)">
          <p class="mb-0">Current Status in Job: {{ candidateEventStatus(timeline) }}</p>
          <p class="mb-0" v-if="candidateEventSource(timeline)">Source: {{ candidateEventSource(timeline) }}</p>
          <p class="mb-0" v-if="candidateEventComment(timeline)">Comment: {{ candidateEventComment(timeline) }}</p>
        </template>
        <p v-else class="mb-0">{{ timeline.description }}</p>
        </div>
      </app-timeline-item>
    </app-timeline>
    <small v-if="safeJobTimeline.length > 50" class="text-muted">Please note only top 50 activities are displayed here, for more activities please contact IT</small>
  </b-card>
</template>

<script>
import {
  BCard, BImg, BMedia, BAvatar,
} from 'bootstrap-vue'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import moment from "moment";
export default {
  data() {
    return {
      jobTime: this.jobTimeline,
      created_at: ''
    }
  },  
  components: {
    BCard,
    BImg,
    BMedia,
    BAvatar,
    AppTimeline,
    AppTimelineItem,
    moment
  },
  props: {
    jobTimeline: {
      type: Array
    },
  },
  created() {
    //this.created_at = moment(this.jobTime.createdAt).format('DD MMM YYYY HH:MM')
  },
  methods: {
    timelineTitle(timeline) {
      return timeline && timeline.title != null ? String(timeline.title) : ''
    },
    timelineTime(timeline) {
      if (!timeline || !timeline.createdAt) return timeline && timeline.createdBy ? `by  ${timeline.createdBy}` : ''
      return String(timeline.createdAt).replace(/T/, ' ').replace(/\..+/, '') + '  by  ' + (timeline.createdBy || '')
    },
    isCandidateTimelineEvent(timeline) {
      if (!timeline) return false
      if (timeline.description === 'CS-Changed' || timeline.candidateStatus || timeline.candidate_status) return true
      const title = String(timeline.title || '')
      return /status changes?/i.test(title)
    },
    candidateEventStatus(timeline) {
      const direct = timeline && (timeline.candidateStatus || timeline.candidate_status || timeline.status)
      if (direct) return direct
      const title = String((timeline && timeline.title) || '')
      const match = title.match(/status changes? to (.+)$/i)
      return match ? match[1].trim() : ''
    },
    candidateEventSource(timeline) {
      return (timeline && timeline.source) || ''
    },
    candidateEventComment(timeline) {
      if (!timeline) return ''
      const own = this.pickRowComment(timeline)
      if (own) return own
      // candidate_jobs.comment is current assignment state — only the latest
      // matching row may use it. Historical Call Back rows keep their own text.
      if (!this.isLatestMatchingCandidateEvent(timeline)) return ''
      return this.pickRowComment(timeline.candidate_jobs)
    },
    pickRowComment(obj) {
      if (!obj) return ''
      const description = obj.description ? String(obj.description).trim() : ''
      if (description && !/^cs-changed$/i.test(description) && !/^previous status/i.test(description)) {
        return description
      }
      const keys = ['comment', 'comments', 'remarks', 'callback_comment', 'callbackComment', 'NA_comment', 'notes']
      for (let i = 0; i < keys.length; i++) {
        const value = obj[keys[i]]
        if (value && typeof value !== 'object' && String(value).trim()) return String(value).trim()
      }
      const extra = obj.extra_details || obj.extraDetails
      const extraObj = typeof extra === 'string' ? (() => { try { return JSON.parse(extra) } catch (e) { return null } })() : extra
      if (extraObj && typeof extraObj === 'object') {
        for (let i = 0; i < keys.length; i++) {
          const value = extraObj[keys[i]]
          if (value && typeof value !== 'object' && String(value).trim()) return String(value).trim()
        }
      }
      return ''
    },
    candidateEventKey(timeline) {
      return this.candidateEventStatus(timeline).toLowerCase().replace(/\s+/g, '')
    },
    isLatestMatchingCandidateEvent(timeline) {
      if (!timeline || !this.isCandidateTimelineEvent(timeline)) return false
      const statusKey = this.candidateEventKey(timeline)
      if (!statusKey) return false
      const list = this.safeJobTimeline.filter(item => (
        this.isCandidateTimelineEvent(item) && this.candidateEventKey(item) === statusKey
      ))
      if (!list.length) return false
      const newest = list.reduce((best, item) => {
        const bestTs = Date.parse(best.createdAt || best.created_at || '') || 0
        const itemTs = Date.parse(item.createdAt || item.created_at || '') || 0
        return itemTs > bestTs ? item : best
      })
      return newest === timeline || (newest && newest.id != null && newest.id === timeline.id)
    },
  },
  computed: {
    safeJobTimeline() {
      return Array.isArray(this.jobTimeline) ? this.jobTimeline : []
    },
    addedOn() {
      
    }
  }  
}
</script>

<style>
.timeline-item {
  padding-bottom: 15px;
}
</style>
